// make the pa-object, imported in index.html accessible
declare var pa:any;

import { paConfig } from '../pianoconfig';

// Partial implementation of URLSearchParams-Object (missing in IE11)
// https://stackoverflow.com/questions/45758837/script5009-urlsearchparams-is-undefined-in-ie-11
(function(w) {
	w.URLSearchParams =
		w.URLSearchParams ||
		function(searchString: String) {
			var self = this;
			self.searchString = searchString;
			self.has = function(el: Object) {
				return self.searchString.indexOf(el) > -1;
			};
			self.get = function(name: String) {
				var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(self.searchString);
				if (results == null) {
					return null;
				} else {
					return decodeURI(results[1]) || 0;
				}
			};
		};
})(window);

let urlParams = new URLSearchParams(document.location.search);
const fId = urlParams.has('fId') === true ? urlParams.get('fId') : '';

// -----
// start of module
const randomIndexOf = (array: Array<any>) => Math.floor(Math.random() * array.length);
const randomOf = (array: Array<any>) => array[randomIndexOf(array)];

pa.setConfigurations(paConfig.configuration);
pa.setProperties(paConfig.params, {'persistent': true, 'events': ['page.*', 'click.*']});


// const Piano = (paPrms = {type:'page.display', prms:{x6:'', x7:'', x8:''}}) => {
// const Piano = (paPrms = {t:'page.display', p:{inhaltstyp:paConfig.params.inhaltstyp, seitenname_id:paConfig.params.seitenname_id, seitentitel:paConfig.params.seitentitel}}) => {
const Piano = (paPrms = {t:'page.display', p:{}}) => {
	let prms = {vorherige_seite:document.referrer};
	Object.keys(paPrms.p).forEach(k => prms[k] = paPrms.p[k]);


	// console.log (`Piano():\n${paPrms.t} => ${JSON.stringify(prms)})`);
	pa.sendEvent(paPrms.t, prms);
	return true;
}	//	/Piano()


export { randomIndexOf, randomOf, Piano, fId };
